import React, { useEffect, useState } from 'react';
import { Form } from '@ant-design/compatible';

import SubCategoryDetailView from './SubCategoryDetailView';
import useSubCategoryList from '../../../../hooks/queries/category/useSubCategoryList';
import useSubCategoryAction from './useSubCategoryAction';
import useSubCategoryFilter from './useSubCategoryFilter';
import { asyncSimpleModal } from '../../../../lib/common';
import { CATEGORY_STATUS_TYPE } from '../../../../constants/service/app/categoryConstants';
import {
  GET_SUB_CATEGORY_LIST_INITIAL_DATA,
  SUB_CATEGORY_ACTION_CONFIRM_MESSAGE,
  SUB_CATEGORY_ACTION_TYPE,
} from './constants';

const SubCategoryDetailContainer = ({ form, categoryStatus }) => {
  const [subCategoryList, setSubCategoryList] = useState([]);

  const {
    data: { subCategories },
  } = useSubCategoryList({
    initialData: GET_SUB_CATEGORY_LIST_INITIAL_DATA,
  });

  const {
    newSubCategory,
    editableRow,
    setEditableRow,
    addRow,
    editRow,
    resetRow,
    createSubCategory,
    editSubCategory,
    deleteSubCategory,
    validateInputPolicy,
  } = useSubCategoryAction(form, subCategoryList);
  const { filterOption, sortOption, subCategoryListWithFilter, dispatchFilter, resetFilter } =
    useSubCategoryFilter(subCategories);

  const confirm = async (type) => {
    const { title, message } = SUB_CATEGORY_ACTION_CONFIRM_MESSAGE[type];

    return await asyncSimpleModal({
      type: 'confirm',
      title,
      message,
    });
  };

  // 서버와의 동기화를 위해 서버에서 받아온 데이터가 달라졌을 경우
  // 새로 받아온 데이터를 categoryList state 에 넣어줌
  useEffect(() => {
    setSubCategoryList(subCategories);
  }, [subCategories]);

  useEffect(() => {
    setSubCategoryList(subCategoryListWithFilter);
  }, [subCategoryListWithFilter]);

  const handleAddRow = () => {
    addRow();
  };
  const handleEditRow = (index, value) => {
    editRow(index, value);
  };
  const handleRemoveRow = async () => {
    if (await confirm(SUB_CATEGORY_ACTION_TYPE.ADD_CANCEL)) {
      resetRow();
    }
  };
  const handleCancelRow = async () => {
    if (await confirm(SUB_CATEGORY_ACTION_TYPE.EDIT_CANCEL)) {
      resetRow();
    }
  };
  const handleCreateSubCategory = async () => {
    const data = form.getFieldsValue();
    const isCheckConfirm = await confirm(SUB_CATEGORY_ACTION_TYPE.CREATE);
    const isCheckValidate = validateInputPolicy({ data });

    if (isCheckConfirm && isCheckValidate) {
      createSubCategory(
        { data },
        {
          onSuccess: () => {
            resetRow();
            resetFilter();
          },
        },
      );
    }
  };
  const handleEditSubCategory = async (subId) => {
    const data = form.getFieldsValue();
    const isCheckConfirm = await confirm(SUB_CATEGORY_ACTION_TYPE.EDIT);
    const isCheckValidate = validateInputPolicy({ subId, data });

    if (isCheckConfirm && isCheckValidate) {
      editSubCategory(
        { subId, data },
        {
          onSuccess: () => {
            resetRow();
            resetFilter();
          },
        },
      );
    }
  };
  const handleDeleteSubCategory = async (subId) => {
    if (await confirm(SUB_CATEGORY_ACTION_TYPE.DELETE)) {
      deleteSubCategory(
        { subId },
        {
          onSuccess: () => {
            resetRow();
          },
        },
      );
    }
  };

  return (
    <SubCategoryDetailView
      form={form}
      categoryList={[...subCategoryList, ...newSubCategory]}
      editableRow={editableRow}
      setEditableRow={setEditableRow}
      onAddRow={handleAddRow}
      onEditRow={handleEditRow}
      onRemoveRow={handleRemoveRow}
      onCancelRow={handleCancelRow}
      onCreateSubCategory={handleCreateSubCategory}
      onEditSubCategory={handleEditSubCategory}
      onDeleteSubCategory={handleDeleteSubCategory}
      filterOption={filterOption}
      sortOption={sortOption}
      dispatchFilter={dispatchFilter}
      onResetFilter={resetFilter}
      disabledAction={categoryStatus === CATEGORY_STATUS_TYPE.INACTIVE}
      disabledFilter={editableRow !== null}
    />
  );
};

export default Form.create()(SubCategoryDetailContainer);
